import React from 'react';

import config from '../../config';
import {type RouteData} from '../types';
import {
  ACCOUNT_SETTINGS_PATHS,
  ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
  USER_SETTINGS_PATH,
} from './accountSettingPaths';

const IS_PRIVATE_ENV = config.ENVIRONMENT_IS_PRIVATE;

/**
 * Account-level routes (user settings, account settings, usage, storage explorer)
 */
export const ACCOUNT_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'UserSettings',
    },
    exact: true,
    isPrivateRoute: true,
    path: USER_SETTINGS_PATH,
    RouteComponent: React.lazy(
      () => import('../../components/UserSettings/UserSettingsPage')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AccountSettings',
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ACCOUNT_SETTINGS_PATHS,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'AccountSettingsUsagePage',
    },
    condition: !IS_PRIVATE_ENV,
    exact: true,
    isPrivateRoute: true,
    path: ACCOUNT_SETTINGS_USAGE_PAGE_PATHS,
    RouteComponent: React.lazy(
      () =>
        import(
          '../../pages/Billing/AccountSettings/ManageUsagePage/ManageUsagePage'
        )
    ),
  },
];
